import { render, staticRenderFns } from "./index.vue?vue&type=template&id=848af23c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=848af23c&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=848af23c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848af23c",
  null
  
)

export default component.exports